import moment from 'moment-timezone';
import React, { Component } from 'react';
import { Alert, Modal } from 'react-bootstrap';
import Datetime from 'react-datetime';
import { connect } from 'react-redux';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { modifyCall, postRescheduleCall, patchRescheduleCall } from '../../actions/call';
import { getServicesList, getServicesListByClient } from '../../actions/outgoingService';
import { filterPhoneNumber, logData, pasteHandler, keyDownHandler } from '../../utils/utils';
import "../../agent/Styles/darktheme.css";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";
import { getItem } from '../../utils/storage';

class RescheduelCall extends Component {

  constructor(props) {
    super(props);
    let defaultValue = moment.tz(this.props.agentInfo.timezone).add(30, 'minutes');
    if(this.props.scheduleDate!==""){
      defaultValue = moment.tz(this.props.scheduleDate * 1000, this.props.agentInfo.timezone);
    }
    this.state = {
      // date: defaultValue.format('DD/MM/YYYY HH:mm'),
      // defaultValue: defaultValue.format('DD/MM/YYYY HH:mm'),
      // dateValue: defaultValue.format('YYYY-MM-DD HH:mm:ss'),
      // dateViewMode: 'days',
      // timeViewMode: 'time',
      // call_id: this.props.CallId,
      // phoneNumber: this.props.phoneNumber,
      // yesterday: Datetime.moment.tz(this.props.agentInfo.timezone).subtract( 1, 'day' )
    }
  }

  /**
   * checks if date is valid
   * @param  {string} current
   * @return {boolean} date validity
   */
  validDate = (current) => {
      return current.isAfter( this.state.yesterday );
  };

  // when modal is opened this is used to populate state
  handleOnEnter = () => {
    this.props.getServicesList();
    this.props.getServicesListByClient();

    let defaultValue = moment.tz(this.props.agentInfo.timezone).add(30, 'minutes');
    if(this.props.scheduleDate!==""){
      defaultValue = moment.tz(this.props.scheduleDate * 1000, this.props.agentInfo.timezone);
    }
    let serviceId = this.props.scheduleService !== ''? this.props.scheduleService.toString() : this.props.serviceId.toString();
    
    this.setState({
      call_id: this.props.CallId,
      schedule_same_agent: this.props.servicesList.some((service) => service.id.toString() === serviceId),
      phoneNumber: this.props.phoneNumber,
      //userTimezone: moment.tz.guess()
      userTimezone: this.props.agentInfo.timezone,
      date: defaultValue.format('DD/MM/YYYY HH:mm'),
      defaultValue: defaultValue.format('DD/MM/YYYY HH:mm'),
      dateValue: defaultValue.format('YYYY-MM-DD HH:mm:ss'),
      dateViewMode: 'days',
      timeViewMode: 'time',
      yesterday: Datetime.moment.tz(this.props.agentInfo.timezone).subtract( 1, 'day' ),
      selectedService: serviceId
    });
  }

  /**
   * updates dateViewMode and dateValue
   * @param  {object} date
   */
  changeDate = (date) => {
    let dateViewMode = this.state.dateViewMode;
    if(this.state.dateViewMode==='days'){
      dateViewMode = 'time';
    }
    // if(!this.validDate(date)){
    //   date = new Date();
    // }
    this.setState({
      dateViewMode,
      dateValue: moment(date).format('YYYY-MM-DD HH:mm:ss')
    });
  }
  /**
   * updates dateViewMode
   * @param  {string} mode
   */
  onViewModeChange = (mode) => {
    this.setState({
      dateViewMode: mode
    });
  }
  /**
   * closes the modal
   * @param  {string} key
   */
  close = (key) => {
    this.setState({
      showErr: false,
      defaultValue: null
    }, () => {
      this.props.handleClose(key);
    });
  }
  // fake a blur event when input is clicked to keep it opened
  handleDatepickerFocus = () => {
    document.getElementById('customId').blur();
  }

  /**
   * updates input value
   * @param  {object} e
   */
  handleChange = (e) => {
    this.setState({[e.target.name] : e.target.value});
  }

  handleServiceChange = (data) => {
    let serviceId = data? data.id.toString() : this.props.serviceId.toString();
    this.setState({ 
      selectedService: serviceId, 
      schedule_same_agent: ( this.props.servicesList.some((service) => service.id.toString() === serviceId) === true? this.state.schedule_same_agent : false ) 
    });
  }

  // handle checkbox value for schedule_same_agent
  handleCheckboxChange = (e) => {
    if(this.state.schedule_same_agent) {
      this.setState({
        schedule_same_agent: !this.state.schedule_same_agent
      });
    }
    else {
      this.setState({
        schedule_same_agent: ( this.props.servicesList.some((service) => service.id.toString() === this.state.selectedService) )
      })
    }
    
  }

  // closes alert box
  handleAlertDismiss = () => {
    this.setState({
      showErr: false
    });
  }
  // updates call schedule
  handleSubmit = () => {
    const { selectedService } = this.state;

    if (!selectedService || selectedService === "0" || selectedService === "") {
      this.setState({
        errorMsg: this.props.translations.allFieldsRequired[this.props.selectedLanguage],
        showErr: true
      });
      return;
    }
    // checks if date is valid (no past date or valid format only).
    if(!moment.tz(this.state.dateValue, this.props.agentInfo.timezone) || this.state.call_id.length==0 ||
      !moment.tz(this.state.dateValue, this.props.agentInfo.timezone).isAfter(moment.tz(this.props.agentInfo.timezone))){
      this.setState({
        errorMsg: this.props.translations.rescheduleCallError[this.props.selectedLanguage],
        showErr: true
      });
      return;
    }else{
      if (this.state.phoneNumber.replace(/ /g,'').match(/[^+\d]/)){
        this.setState({
          errorMsg: this.props.translations.onlyNumbers[this.props.selectedLanguage],
          showErr: true
        });
        return;
      }
      let phoneNumber =  filterPhoneNumber(this.state.phoneNumber);
      // autodialerFormatCallId
      const callIdString = this.state.call_id;
      const callIdFirstChar = callIdString.charAt(0);
      let formattedCallId = callIdString;
      if (callIdFirstChar == 1)
        formattedCallId = callIdString.slice(0, 3) +"-"+callIdString.slice(3,13)+"."+callIdString.slice(13);
      else {
        formattedCallId = callIdString.slice(0, 2) +"-"+callIdString.slice(2,12)+"."+callIdString.slice(12);
      }

      // In case listDetailId = 0 means that the call doesn't have any autodialer id record registered
      // thus we need to make a post request. If it is >0 then a record is already registered and we have
      // to make a patch request
      if(this.props.listDetailId == 0){
       // console.log(this.props.listDetailId);
      const payload = {
        call_id: formattedCallId,
        priority: 0,
        service: {
          "id": this.state.selectedService,
        },
        is_scheduled: true,        
        scheduled: {
          date: moment.tz(this.state.dateValue, 'YYYY-MM-DD HH:mm', this.props.agentInfo.timezone).unix(),
          same_agent: this.state.schedule_same_agent ? true : false,
        },
        timezone: this.props.agentInfo.timezone,
        phone_list: [
          {
            phone: phoneNumber,
            priority: 1
          }
        ],
      }

        if (this.state.schedule_same_agent == 1) {
          payload.scheduled.agent = {
            id: parseInt(localStorage.getItem("agent_id")),
          };


      }
      // makes api call from action. Either is it post or patch request
      this.props.postRescheduleCall(payload).then((res) => {
        if(res.data.result){
          const schedule_date = moment.tz(payload.schedule_date, 'YYYY-MM-DD HH:mm', this.props.agentInfo.timezone).unix();
          const schedule_service = payload.service_id;
          if(this.props.rescheduleCallCb!==null){
            this.props.rescheduleCallCb(formattedCallId, schedule_date, schedule_service);
            const newData = {
              id: formattedCallId,
              schedule_date: schedule_date,
              schedule_service: schedule_service
            };
            this.props.modifyCall(newData);
          }
          this.props.getCalls()
          this.setState({
            showErr: false,
            defaultValue: null
            // defaultValue: moment.tz(schedule_date * 1000, this.props.agentInfo.timezone).format('DD/MM/YYYY HH:mm')
          }, () => {
            this.props.handleClose(this.props.showModal);
          })
        }else{
          this.setState({
            errorMsg: res.data.description || this.props.translations.commonErrorText[this.props.selectedLanguage],
            showErr: true
          });
        }
      }, (err) => {
        this.setState({
          errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage],
          showErr: true
        });
        logData(err);
      });
      } else {
        //console.log('patch',this.props.listDetailId);
        const payload = {
          id: this.props.listDetailId,
          data: {
            service: {
              id: this.state.selectedService,
            },
            timezone: this.props.agentInfo.timezone,
            is_scheduled: true,
            scheduled: {
              date: moment.tz(this.state.dateValue, 'YYYY-MM-DD HH:mm', this.props.agentInfo.timezone).unix(),
              same_agent: this.state.schedule_same_agent ? true : false,
              ...(this.state.schedule_same_agent ? 
                { agent: 
                  { id: parseInt(localStorage.getItem("agent_id")) } } : {}
                ),
            },
          },
        };
        this.props.patchRescheduleCall(payload,this.props.listDetailId).then((res) => {
          if(res.data.result){
            const schedule_date = payload.data.scheduled.date
            const schedule_service = this.state.selectedService;
            if(this.props.rescheduleCallCb!==null){
              this.props.rescheduleCallCb(formattedCallId, schedule_date, schedule_service);
              const newData = {
                id: formattedCallId,
                schedule_date: schedule_date,
                schedule_service: schedule_service
              };
              this.props.modifyCall(newData);
            }
            this.props.getCalls()
            this.setState({
              showErr: false,
              defaultValue: null
              // defaultValue: moment.tz(schedule_date * 1000, this.props.agentInfo.timezone).format('DD/MM/YYYY HH:mm')
            }, () => {
              this.props.handleClose(this.props.showModal);
            })
          }else{
            this.setState({
              errorMsg: res.data.description || this.props.translations.commonErrorText[this.props.selectedLanguage],
              showErr: true
            });
          }
        }, (err) => {
          this.setState({
            errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage],
            showErr: true
          });
          logData(err);
        });
      }
    }
  }

  render(){
    const { schedule_same_agent } = this.state;
    const { translations, selectedLanguage } = this.props;
    return (
      <Modal
        onEntering={this.handleOnEnter}
        show={this.props.showModal}
        onHide={() => this.close(this.props.showModal)}
        backdrop="static"
      >
        <Modal.Header className={`modal-content${this.props.theme}`} closeButton>
          <Modal.Title>{translations.rescheduleCall[selectedLanguage]}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={`modal-content${this.props.theme}`} style={ { overflow:'visible' } }>
          {this.state.showErr && <div className="alertWrapper"><Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
            <p>{this.state.errorMsg}</p>
          </Alert></div>}
          <div className="row">
          <div className="form-group col-md-7">
            <label id="test" htmlFor="exampleInputEmail1">{translations.phoneNumber1[selectedLanguage]}</label>
            <input
              type="text"
              ref="phone"
              value={this.state.phoneNumber}
              name="phoneNumber"
              className={`form-control${this.props.theme} input-sm${this.props.theme}`}
              onChange={this.handleChange}
              onKeyDown={(event) => keyDownHandler(event, "allowNumbersAndChars")}
              onPaste={(event) => pasteHandler(event, "allowNumbersAndChars")}
              placeholder="Phone"
            />
          </div>
          {this.state.defaultValue && <div className="form-group col-md-5">
            <label htmlFor="exampleInputEmail1">{translations.dateAndTime[selectedLanguage]}</label>
            <Datetime
              locale={moment.locale(selectedLanguage)}
              defaultValue={this.state.defaultValue}
              viewMode={this.state.dateViewMode}
              onChange={this.changeDate}
              onViewModeChange={this.onViewModeChange}
              isValidDate={ this.validDate }
              dateFormat="DD/MM/YYYY"
              timeFormat="HH:mm"
              utc
              inputProps={{onClick: this.handleDatepickerFocus, id: 'customId' }}
            />
          </div>}
          </div>  
          <div className="row">
            <div className="form-group col-md-7">
              <label>{translations.service[selectedLanguage]}</label>
              <Select
                onChange={this.handleServiceChange}
                value={this.state.selectedService}
                placeholder="select"
                options={this.props.serviceListByClient}
                labelKey="name"
                valueKey="id"
                noResultsText={translations.noResultsText[selectedLanguage]}
              />
            </div>
            <div className="form-group col-md-5">
              <div className="checkbox" style={{marginTop: "30px", marginBottom: "0px"}}>
                <label className="control control--checkbox" style={{marginBottom: "0px"}}>{translations.sameAgent[selectedLanguage]}
                  <input
                    type="checkbox"
                    checked={ schedule_same_agent }
                    onChange={ this.handleCheckboxChange }
                  />
                  <div className="control__indicator" />
                </label>
              </div>
            </div>
          </div>
          
        </Modal.Body>
        <Modal.Footer className={`modal-content${this.props.theme}`}>
          <button
            type="button"
            onClick={() => this.close(this.props.showModal)}
            className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`}
            data-dismiss="modal">
            {translations.cancel[selectedLanguage]}
          </button>
          <button
            type="submit"
            onClick={() => this.handleSubmit()}
            className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`}
            data-dismiss="modal">
            <strong>{translations.save[selectedLanguage]}</strong>
          </button>
        </Modal.Footer>
      </Modal>
    )
  }
}

function mapStateToProps  (state) {
    return {
        agentInfo: state.agentInfo,
        translations: state.languages.translations,
        selectedLanguage: state.languages.selectedLanguage,
        serviceListByClient: state.agentsAndSupervisors.serviceListByClient,
        servicesList: state.servicesList,
        darkMode: state.common.darkMode,
        theme: state.common.theme,
    };
}

function mapDispatchToProps (dispatch) {
    return bindActionCreators({
      postRescheduleCall,
      patchRescheduleCall,
      modifyCall,
      getServicesListByClient,
      getServicesList
    }, dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(RescheduelCall);



// WEBPACK FOOTER //
// ./src/agent/modals/RescheduleCall.js